import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import SplashScreen from "src/components/splash-screen";
import DashboardLayout from "src/layouts/dashboard";
import DisableCarrierPage from "./dashboard/disable-carrier/disable-carrier-page";

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import("src/pages/dashboard"));
const SelectUnlockItemsPage = lazy(
	() => import("src/pages/dashboard/select-unlock-items/select-unlock-items-page"),
);

const AddTripPage = lazy(() => import("src/pages/dashboard/trip/trip-create-page"));
const EditTripPage = lazy(() => import("src/pages/dashboard/trip/trip-edit-page"));
const AddLoadPage = lazy(() => import("src/pages/dashboard/load/load-create-page"));
const LoadDetailPage = lazy(() => import("src/pages/dashboard/load/load-detail-page"));
const ProfileEditPage = lazy(() => import("src/pages/dashboard/profile/profile-edit-page"));

const LoadManagementPage = lazy(() => import("src/pages/dashboard/load-management"));
const TripTrackingPage = lazy(() => import("src/pages/dashboard/trip/trip-tracking-page"));
const CreateCarrierPage = lazy(() => import("src/pages/dashboard/carrier/carrier-create-page"));
// const EditCarrierPage = lazy(
//   () => import('src/pages/dashboard/carrier/edit-carrier'),
// );
const CarrierListPage = lazy(() => import("src/pages/dashboard/carrier/carrier-list-page"));
const PremiumPlansPage = lazy(() => import("src/pages/dashboard/plans/plans-page"));
const TruckVisualPage = lazy(() => import("src/pages/dashboard/truck-visual/truck-visual-page"));

const PaymentPage = lazy(() => import("src/pages/dashboard/payment/payment-page"));
const TripsPage = lazy(() => import("src/pages/dashboard/trip/components/trip-list"));
const ReportsPage = lazy(() => import("src/pages/dashboard/reports/reports-page"));
const CalculatorPage = lazy(() => import("src/pages/dashboard/calculator/components/calculator"));
const CalculatorDetailPage = lazy(
	() => import("src/pages/dashboard/calculator/calculator-detail-page"),
);
const CalculatorScenarioPage = lazy(
	() => import("src/pages/dashboard/calculator/calculator-scenario-page"),
);
const TrucksPage = lazy(() => import("src/pages/dashboard/truck/trruck-list-page"));
const AddTruckPage = lazy(() => import("src/pages/dashboard/truck/truck-create-page"));
const AddDriverPage = lazy(() => import("src/pages/dashboard/driver/driver-create-page"));
const DriversPage = lazy(() => import("src/pages/dashboard/driver/driver-list-page"));
const ReferralPage = lazy(() => import("src/pages/dashboard/referral/referral-page"));
const ReferralUsagePage = lazy(
	() => import("src/pages/dashboard/referral-usage/referral-usage-page"),
);
const HelpVideoPage = lazy(() => import("src/pages/dashboard/help/help-page"));
const TransactionPage = lazy(() => import("src/pages/dashboard/transaction/transaction-page"));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
	{
		path: "dashboard",
		element: (
			<AuthGuard>
				<DashboardLayout>
					<Suspense fallback={<SplashScreen />}>
						<Outlet />
					</Suspense>
				</DashboardLayout>
			</AuthGuard>
		),
		children: [
			{ element: <IndexPage />, index: true },
			{ element: <AddTripPage />, path: "trip/add" },
			{ element: <SelectUnlockItemsPage />, path: "select-unlock-items" },
			{ element: <EditTripPage />, path: "trip/edit/:tripId" },
			{ element: <AddLoadPage />, path: "load/add" },
			{ element: <LoadDetailPage />, path: "load/:id" },
			{ element: <ProfileEditPage />, path: "profile-edit" },
			{ element: <LoadManagementPage />, path: "load-management/:tripId" },
			{ element: <TripTrackingPage />, path: "trip-tracking/:tripId" },
			{ element: <CreateCarrierPage />, path: "create-carrier" },
			// { element: <EditCarrierPage />, path: 'edit-carrier' },
			{ element: <CarrierListPage />, path: "carriers" },
			{ element: <PremiumPlansPage />, path: "premium-plans" },
			{ element: <TruckVisualPage />, path: "truck-visual" },
			{ element: <PaymentPage />, path: "payment" },
			{ element: <TripsPage />, path: "trips" },
			{ element: <DisableCarrierPage />, path: "disable-carrier" },
			{ element: <ReportsPage />, path: "reports" },
			{ element: <CalculatorPage />, path: "calculator" },
			{ element: <CalculatorDetailPage />, path: "calculator/:truckId" },
			{
				element: <CalculatorScenarioPage />,
				path: "calculator/scenario/:truckId",
			},
			{ element: <TrucksPage />, path: "trucks" },
			{ element: <AddTruckPage />, path: "trucks/add" },
			{ element: <AddTruckPage />, path: "trucks/add/:truckId" },
			{ element: <DriversPage />, path: "drivers" },
			{ element: <AddDriverPage />, path: "drivers/add" },
			{ element: <AddDriverPage />, path: "drivers/add/:driverId" },
			{ element: <ReferralPage />, path: "referral" },
			{ element: <ReferralUsagePage />, path: "referral/usage" },
			{ element: <HelpVideoPage />, path: "help-video" },
			{ element: <TransactionPage />, path: "transaction" },
		],
	},
];
